
import React from 'react'

function UpdatedBadge(props) {
    const { height, width, image, style: { color }, top, left} = props;

    return (
      <>
        <div
          style={{
            position: "relative",
            height: height,
            width: width,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            {...props}
          >
            <defs>
              <filter id="a">
                <feOffset />
                <feGaussianBlur result="blur" stdDeviation={19} />
                <feFlood floodOpacity={0.161} result="color" />
                <feComposite in="SourceGraphic" in2="blur" operator="out" />
                <feComposite in="color" operator="in" />
                <feComposite in2="SourceGraphic" operator="in" />
              </filter>
            </defs>
            <g data-type="innerShadowGroup">
              <circle
                cx={width / 2}
                cy={width / 2}
                r={width / 2}
                fill={color || "none"}
                data-name="Ellipse 199"
              />
              <g filter="url(#a)">
                <circle
                  cx={width / 2}
                  cy={width / 2}
                  r={width / 2}
                  fill="none"
                  data-name="Ellipse 199"
                />
              </g>
              <g
                fill="none"
                stroke="#707070"
                strokeWidth={5}
                data-name="Ellipse 199"
              >
                <circle
                  cx={width / 2}
                  cy={width / 2}
                  r={width / 2}
                  stroke="none"
                />
                <circle cx={width / 2} cy={width / 2} r={95.5} stroke='none' />
              </g>
            </g>
          </svg>

          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translateX(-50%) translateY(-50%)",
              display: "flex",
            }}
          >
            {image && (
              <img
                src={image}
                width={width / 2}
                height={height / 2}
                draggable="false"
                style={{ marginBootm: "-3px", objectFit: "cover" }}
              />
            )}
          </div>
        </div>
      </>
    );
}

export default UpdatedBadge